import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ElfNgRouterStoreModule } from '@ngneat/elf-ng-router-store';

import { AuraAuthenticationGuardsModule } from '@digital-platform/aura-authentication/guards';
import { RsAnalyticsServiceModule } from '@digital-platform/rs-analytics/services';
import { RsClassicUiModule } from '@digital-platform/rs-classic/ui';
import { RsCmsFeatureCmsPageModule } from '@digital-platform/rs-cms/feature-cms-page';
import { RsFrontendLocationsRedirectModule } from '@digital-platform/rs-frontend/locations-redirect';
import { RsFrontendUiModule } from '@digital-platform/rs-frontend/ui';
import { RsFrontendShellRoutingModule } from './rs-frontend-shell-routing.module';
import { ShellComponent } from './shell/shell.component';
import { TestPageComponent } from './test-page/test-page.component';

@NgModule({
  imports: [
    CommonModule,
    ElfNgRouterStoreModule,
    RsClassicUiModule,
    RsAnalyticsServiceModule,
    RsFrontendShellRoutingModule,
    RsFrontendUiModule,
    RsCmsFeatureCmsPageModule,
    RsFrontendLocationsRedirectModule,
    AuraAuthenticationGuardsModule,
  ],
  declarations: [ShellComponent, TestPageComponent],
})
export class RsFrontendShellModule {}
